import classNames from "classnames";
import React, { useMemo } from "react";
import { WSElement } from "../WSElement/WSElement.component";
import { WSLabel, WSLabelProps } from "../WSLabel/WSLabel";
import styles from "./WSCardHeader.module.scss";
import { WSCardHeaderValue, WSCardHeaderValueProps } from "./WSCardHeaderValue";

export type WSCardHeaderProps = {
  label?: string | WSLabelProps;
  value?: WSCardHeaderValueProps;
  className?: string;
};

export const WSCardHeader: React.FC<WSCardHeaderProps> = (props) => {
  const labelProps = useMemo(() => {
    if (typeof props.label === "string") {
      return {
        text: props.label
      };
    }
    return props.label;
  }, [props.label]);

  return (
    <WSElement className={classNames(styles.header, props.className)}>
      <WSLabel {...labelProps} />
      {props.value && <WSCardHeaderValue {...props.value} />}
    </WSElement>
  );
};
